<template>
    <div class="article-contact">
        <p>Interested in working with me? Have enquiries about events or availability? Just fancy sending some love?</p>
        <p>Please drop me a message and I will reply as soon as possible - thank you!</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
